module.exports = __webpack_public_path__ + "img/protecaoEficazVermelho.02801482.svg";